import React from "react";

const Header: React.FC<{ count: number }> = ({ count }) => {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a className="brand" href="#top" aria-label="Kozhikode Food Map home">
          <i className="fa-solid fa-utensils brand__icon" aria-hidden="true" />
          <span>Kozhikode Food Map</span>
        </a>
        <div className="header-meta">
          <span className="header-meta__count">
            <i className="fa-solid fa-location-dot" aria-hidden="true" style={{ marginRight: 6 }} />
            {count} spots curated
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;